import { ANIMATIONS, FOOTER } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Reveal {

  constructor(context) {
    this.context = context;
    ANIMATIONS && this.init();
  }

  init() {
    FOOTER && gsap.fromTo(".footer",
      {
        'will-change': 'transform',
        y: "-100%",
      },
      {
        ease: 'linear',
        y: "0",
        scrollTrigger: {
          trigger: ".footer",
          start: "top 70%",
          end: "bottom 60%",
          scrub: true,
          markers: false,
        }
      });
  }
}
